import React from 'react';
import ProductItemTitles from '../Shared/ProductItemTitles';
import {ColumnHtml, ColumnTwoPartsHtml, ColumnHtmlWithIcon} from '../Shared/sharedHtmlComponents';
import {productStatus} from '../productsAndServicesBlockSlice';
import ProductStatus from '../Shared/ProductStatus';
import CategoryName from '../Shared/CategoryName';
import {isMobile} from 'react-device-detect';
import {productsTypes, internetTypesDescription} from '../productsAndServicesBlockSlice';
const InternetItem = (props) => {
  const infraItemTitles = ['מוצר', 'חבילה', 'מהירות גלישה', 'כתובת התקנה'];
  const infraISPTitles = ['מוצר', 'משתמש', 'כתובת דואר אלקטרוני', 'חבילה'];
  const widthList = ['20', '30', '25', '25'];

  return (
    <div className={`productAndServicesItemContainer ${props.type}`}>
      <CategoryName
        title={'אינטרנט'}
        imageName={`${isMobile ? 'internet' : 'internet-desc'}`}
        goToAction={props.goToAction}
        actions={props.internetActions}
        allActionButtonText={props.allActionButtonText}
        goToAllAction={props.goToAllAction}
        type={productsTypes.INTERNET}
      />

      {props.infra && (
        <>
          {!isMobile && <ProductItemTitles titlesList={infraItemTitles} widthList={widthList} />}
          {props.infra &&
            props.infra?.map((infraItem, index) => {
              const subscriberNo = infraItem.subscriberNumber;
              const ban = infraItem.ban;
              const type = internetTypesDescription[infraItem.internetSubType];
              const status =
                infraItem.productStatus == productStatus.BUSINESS ||
                infraItem.productStatus == productStatus.CANCELLED ||
                infraItem.productStatus == productStatus.SUSPENDED
                  ? infraItem.productStatus
                  : null;
              return (
                <div key={index}>
                  {!isMobile ? (
                    <div className='productAndServicesItemContainer_content_wrapper d-flex'>
                      {status && <ProductStatus status={status} />}
                      <ColumnHtml item={type} columnWidth={widthList[0]} customClass={'semiBold'} />
                      {ban && subscriberNo ? (
                        <ColumnHtmlWithIcon
                          item={infraItem.packageName}
                          columnWidth={widthList[1]}
                          buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                        />
                      ) : (
                        <ColumnHtml item={infraItem.packageName} columnWidth={widthList[1]} />
                      )}

                      <ColumnHtml item={infraItem.downloadSpeed + 'Mb'} columnWidth={widthList[2]} />
                      <ColumnHtml item={infraItem.customerAddress} columnWidth={widthList[3]} />
                    </div>
                  ) : (
                    <div className='productAndServicesItemContainer_content_wrapper'>
                      <ColumnTwoPartsHtml title={type} titleCustomClass={'semiBold black'} textCustomClass={'status'}>
                        {status && <ProductStatus status={status} />}
                      </ColumnTwoPartsHtml>
                      {ban && subscriberNo ? (
                        <ColumnTwoPartsHtml title={infraItemTitles[1]}>
                          <ColumnHtmlWithIcon
                            item={infraItem.packageName}
                            buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                          />
                        </ColumnTwoPartsHtml>
                      ) : (
                        <ColumnTwoPartsHtml title={infraItemTitles[1]} text={infraItem.packageName} />
                      )}

                      <ColumnTwoPartsHtml title={infraItemTitles[2]} text={infraItem.downloadSpeed + 'Mb'} />
                      <ColumnTwoPartsHtml title={infraItemTitles[3]} text={infraItem.customerAddress} />
                    </div>
                  )}
                </div>
              );
            })}
        </>
      )}
      {props.isp && (
        <>
          <ProductItemTitles titlesList={infraISPTitles} widthList={widthList} />
          {props.isp?.map((ispItem, index) => {
            const subscriberNo = ispItem.subscriberNumber;
            const ban = ispItem.ban;
            const status =
              ispItem.productStatus == productStatus.BUSINESS ||
              ispItem.productStatus == productStatus.CANCELLED ||
              ispItem.productStatus == productStatus.SUSPENDED
                ? ispItem.productStatus
                : null;
            return (
              <div key={index}>
                {!isMobile ? (
                  <div key={index} className='productAndServicesItemContainer_content_wrapper d-flex'>
                    {status && <ProductStatus status={status} />}
                    <ColumnHtml item={'ספק'} columnWidth={widthList[0]} customClass={'semiBold'} />
                    {ban && subscriberNo ? (
                      <ColumnHtmlWithIcon
                        item={ispItem.packageName}
                        columnWidth={widthList[1]}
                        buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                      />
                    ) : (
                      <ColumnHtml item={ispItem.packageName} columnWidth={widthList[1]} />
                    )}

                    <ColumnHtml item={ispItem.userName} columnWidth={widthList[2]} />
                    <ColumnHtml item={ispItem.email} columnWidth={widthList[3]} />
                  </div>
                ) : (
                  <div className='productAndServicesItemContainer_content_wrapper'>
                    <ColumnTwoPartsHtml title={'ספק'} titleCustomClass={'semiBold black'} textCustomClass={'status'}>
                      {status && <ProductStatus status={status} />}
                    </ColumnTwoPartsHtml>

                    {ban && subscriberNo ? (
                      <ColumnTwoPartsHtml title={infraISPTitles[1]}>
                        <ColumnHtmlWithIcon
                          item={ispItem.packageName}
                          buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                        />
                      </ColumnTwoPartsHtml>
                    ) : (
                      <ColumnTwoPartsHtml title={infraISPTitles[1]} text={ispItem.packageName} />
                    )}

                    <ColumnTwoPartsHtml title={infraISPTitles[2]} text={ispItem.userName} />
                    <ColumnTwoPartsHtml title={infraISPTitles[3]} text={ispItem.email} />
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};
export default InternetItem;
